'use strict';

$(document).ready(function () {
  ////////////////////////////////////
  // MODEL ANSWER EVENTS
  ////////////////////////////////////

  $('.page-model__comment--answer').click(function (e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('active');
  });
  $('.page-model__comment--add-answer .close').click(function (e) {
    return e.target.parentElement.parentElement.parentElement.classList.remove('active');
  });
  $('.page-model__answer .close').click(function (e) {
    return e.target.closest('.page-model__answer').classList.toggle('active');
  });
  $('.tree-input-toggler').click(function (e) {
    e.preventDefault();
    e.target.closest('.page-model__answer').classList.toggle('active');
  });
  //settings active toggler
  $(".page-settings__content--row a").click(function (e) {
    e.preventDefault();
    e.target.closest(".page-settings__content--row").classList.toggle('active');
  });
  //Payed services section toggler
  $(".main__aside--paid").click(function (e) {
    e.preventDefault();
    e.target.closest(".main__aside--paid").classList.toggle('open');
  });
  ////////////////////////////////////
  // UPLOAD IMAGE
  ////////////////////////////////////
  var uploadImgCount = $("#photo-upload").children().length;

  $("#avatar").change(handelChangeAvatar);

  //preview for the avatar
  $(".add__content--photo input").change(handleChange);
  $("#rm-avatar").click(function (e) {
    e.preventDefault();
    $("#avatar").val('');
    $("#settings_photo").attr("src", "./img/avator_full.jpg");
  });
  function handelChangeAvatar(_ref) {
    var target = _ref.target;

    if (target.files && target.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        $("#settings_photo").attr("src", e.target.result);
      };

      reader.readAsDataURL(target.files[0]);
    }
  }

  function handleChange() {
    $("#" + this.id).parent(".add").removeClass('add').addClass('loaded');
    setPreview(this);
    $('label[for="foto' + (uploadImgCount - 1) + '"]').prop('for', '');
    $(".add__content--photo.add input").change(handleChange);
    $('.loaded .close').click(delImage);
  }

  function createUploadField(number) {
    var el = $('<div class="add__content--photo add">\n      <label for="foto' + number + '"><img class="photo-img" id="img' + number + '" src="" alt="">\n        <div class="close"></div>\n      </label>\n      <input id="foto' + number + '" type="file">\n    </div>');
    $("#photo-upload").append(el);
  }

  function setPreview(self) {
    createUploadField(++uploadImgCount);
    if (self.files && self.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        $("#img" + (uploadImgCount - 1)).attr("src", e.target.result);
      };

      reader.readAsDataURL(self.files[0]);
    }
  }

  function delImage(_ref2) {
    var target = _ref2.target;

    var el = target.parentElement && target.parentElement.parentElement;
    el.parentElement.removeChild(el);
  }

  ////////////////////////////////////
  // S E L E C T I Z E
  ////////////////////////////////////
  $("#input-sort").selectize({ create: true, sortField: "text" });
  $("#input-region").selectize({ create: true, sortField: "text" });
  var $cat = $("#category").selectize({ create: true, sortField: "text" });
  var $subCat = $("#sub-category").selectize({
    create: true,
    sortField: "text"
  });
  $("#location").selectize({ create: true, sortField: "text" });
  $("#quality").selectize({ create: true, sortField: "text" });

  var cat = $cat[0].selectize;
  var subCat = $subCat[0].selectize;
  subCat.disable();
  cat.on("change", function (e) {
    return e === "all" ? (subCat.disable(), subCat.setValue("all")) : subCat.enable();
  });

  $("#comments-sort").selectize({ create: true, sortField: "text" });

  $("#form-quality").selectize({ create: true, sortField: "text" });
  $("#form-category").selectize({ create: true, sortField: "text" });
  $("#form-region").selectize({ create: true, sortField: "text" });

  ////////////////////////////////////
  // MAGNIFIC POPUP
  ////////////////////////////////////
  $(".full-screen").magnificPopup({
    type: "image",
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: "mfp-no-margins mfp-with-zoom",
    image: {
      verticalFit: true
    }
  });
  ////////////////////////////////////
  // OWL CAROUSEL
  ////////////////////////////////////

  var vipSlider = $("#vip-slider").owlCarousel({
    loop: true,
    margin: 0,
    dots: false,
    items: 1,
    center: true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      640: {
        items: 3
      },
      870: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  $("#vip-next").click(function (e) {
    e.preventDefault();
    vipSlider.trigger("next.owl.carousel");
  });
  $("#vip-prev").click(function (e) {
    e.preventDefault();
    vipSlider.trigger("prev.owl.carousel");
  });

  ////////////////////////////////////
  // CLICK EVENTS
  ////////////////////////////////////

  $("#list").click(function (e) {
    $("#grid").removeClass("active");
    $("#list").addClass("active");
  });

  $("#grid").click(function (e) {
    $("#list").removeClass("active");
    $("#grid").addClass("active");
  });

  $("#filter-button").click(function (e) {
    e.preventDefault();
    $("#filter-section").toggleClass("active");
  });

  $(".close").click(function (e) {
    $(".notification").addClass("hidden");
  });

  $(".notice__toggler").click(function (e) {
    e.preventDefault();
    $(".notice").toggleClass("toggled");
  });
});
//# sourceMappingURL=main.min.js.map
